import styled from 'styled-components';
import { layoutSizes, colours } from "../../../../constants/css";
export var Description = styled.p.withConfig({
  displayName: "style__Description",
  componentId: "sc-1rucz8v-0"
})(["font-size:1.25rem;line-height:1.2;color:", ";margin:5px 0;text-align:center;@media only screen and (min-width:", "){text-align:left;font-size:1.375rem;line-height:1.18;width:248px;}"], colours.qantasCharcoal, layoutSizes.desktopWidth);